<template>
  <section class="new-flow">
    <application-menu :app="app" v-if="app"></application-menu>
    <form class="ui info success warning error form" autocomplete="off">
      <div class="ui basic search segment">
        <h4 class="ui horizontal header">
          {{ $t('HUB_SEARCH_AND_GET_HEADER') }}
        </h4>
        <p>{{ $t('HUB_SEARCH_AND_GET_BODY') }}</p>
        <div class="ui three fields">
          <!-- SEARCH TERM -->
          <div class="field">
            <label>{{ $t('SEARCH') }}</label>
            <input type="text" name="name" v-model="searchTerm" />
          </div>

          <!-- CATEGORY -->
          <dropdown-select
            :labelText="$tc('CATEGORY', 1)"
            :items="categoryItems"
            :optional="true"
            @selected="selectCategory"
          />

          <!-- APPLICATION -->
          <dropdown-select
            :labelText="$tc('APPLICATION', 1)"
            :items="applicationItems"
            :optional="true"
            @selected="selectApplication"
          />
        </div>
      </div>

      <div class="ui basic content segment">
        <Spinny
          :promise="publicationsPromise"
          :showError="true"
          :message="$t('READ', { thing: $tc('PUBLICATION', 2) })"
        />

        <div class="ui info message" v-if="filteredFlows.length === 0 && !hubErr">
          {{ $t('NO_ITEMS_MATCH', { things: $tc('PUBLICATION', 10) }) }}
        </div>
        <div class="ui error message" v-else-if="hubErr">
          {{ $t('ERR_LOADING_FROM_HUB', { err: hubErr }) }}
        </div>

        <PublicationGetter
          v-for="p in filteredFlows"
          :appId="appId"
          :publication="p"
          :connection="connectionFor(p)"
          :flow="downloadedFlow(p)"
          :condensed="true"
          :showAbstract="true"
          :applications="applications"
          :categories="categories"
          :key="'pub_' + p.identifier"
        />
      </div>
    </form>
  </section>
</template>

<style lang="scss" scoped>
form {
  display: flex;
  flex-flow: column;
  height: 100%;
}
div.search {
}
div.content {
  flex-grow: 1;
  overflow-y: scroll;
  padding-bottom: 50px;
}
</style>

<script>
// @flow
import Vue from 'vue'
import _ from 'lodash'
import ApplicationMenu from './../Applications/ApplicationMenu'
import PublicationGetter from './PublicationGetter'
import { Hub, Flow, Toast } from 'services'
import { DropdownSelect, Spinny } from 'ui'

export default {
  name: 'download-flow',
  components: { ApplicationMenu, DropdownSelect, PublicationGetter, Spinny },

  props: ['appId'],

  data() {
    return {
      publications: [],
      selectedApplication: null,
      selectedCategory: null,
      searchTerm: '',
      publicationsPromise: null
    }
  },

  computed: {
    hubErr() {
      return this.$store.state.hub.loadingErr
    },
    connections() {
      return this.$store.state.hub.connections
    },
    hubs() {
      return this.$store.state.hub.hubs
    },
    categories() {
      return _.keyBy(this.$store.state.hub.categories, 'identifier')
    },
    applications() {
      return _.keyBy(this.$store.state.hub.applications, 'identifier')
    },
    licenses() {
      return _.keyBy(this.$store.state.hub.licenses, 'identifier')
    },
    filteredFlows() {
      return _.filter(this.publishedFlows, p => {
        return (
          (!this.selectedApplication || p.application === this.selectedApplication.identifier) &&
          (!this.selectedCategory || p.category === this.selectedCategory.identifier) &&
          [p.abstract, p.name].some(s => s.indexOf(this.searchTerm) >= 0)
        )
      })
    },
    publishedFlows() {
      return _.filter(
        this.publications,
        p => Hub.INLINED_FLOW_PUBLICATION === p.type || Hub.FLOW_PUBLICATION === p.type
      )
    },
    app() {
      return _.find(this.$store.state.application.items, a => a.id === this.appId)
    },
    flows() {
      return this.$store.state.flow.items
    },
    categoryItems() {
      return _.map(_.values(this.categories), c => {
        return { id: c.identifier, ...c }
      })
    },
    applicationItems() {
      return _.map(_.values(this.applications), a => {
        return { id: a.identifier, ...a }
      })
    }
  },

  methods: {
    connectionFor(p) {
      return _.find(
        this.connections,
        c => c.hub.id === (this.hubs && this.hubs[p.origin.hub]?.hub?.id)
      )
    },
    selectCategory(c) {
      this.selectedCategory = c
    },
    selectApplication(a) {
      this.selectedApplication = a
    },
    downloadedFlow(p) {
      return _.find(this.flows, f => f.id === p.identifier)
    }
  },

  created() {
    // Load all flows
    Flow.readAllFlows()

    Hub.list()

    this.publicationsPromise = Hub.connections().then(conns => {
      // Load publications
      return Promise.allSettled(_.flatMap(conns, Hub.latest)).then(pubs => {
        const items = _.flatMap(
          _.filter(pubs, p => p.status === 'fulfilled'),
          p => p.value && p.value.body && p.value.body.items
        )
        this.publications = _.uniqBy(items, item => item.identifier)
      })
    })
  }
}
</script>
